import { Guid } from "guid-typescript";
import {UserPreference} from "@/models/system/user/UserPreference";

export class GeneralRequest {
    requestId: Guid = Guid.create();
}

export class LoginRequest extends GeneralRequest {
    email:string = "";
    password:string = "";
    rememberMe: boolean = false;

    constructor(email: string, password: string, rememberMe: boolean)
    {
        super();
        this.email = email;
        this.password = password;
        this.rememberMe = rememberMe;
    }
}

export class RefreshTokenRequest extends GeneralRequest {
    accessToken:string;

    constructor(accessToken:string){
        super();
        this.accessToken = accessToken;
    }
}

export class ResetPasswordEmailRequest extends GeneralRequest {
    email:string = "";
    url:string = "";

    constructor(email:string, url:string){
        super();
        this.email = email;
        this.url = url;
    }
}

export class ResetPasswordRequest extends GeneralRequest {
    token:string;
    email:string;
    password:string;
    passwordRepetition:string;

    constructor(token:string, email:string, password:string, passwordRepetition:string){
        super();
        this.token = token;
        this.email = email;
        this.password = password;
        this.passwordRepetition = passwordRepetition;
    }
}

export class ChangePasswordRequest extends GeneralRequest {
    userId:string;
    oldPassword:string;
    newPassword:string;
    newPasswordRepetition:string;

    constructor(userId:string, oldPassword:string, newPassword:string, newPasswordRepetition:string){
        super();
        this.userId = userId;
        this.oldPassword = oldPassword;
        this.newPassword = newPassword;
        this.newPasswordRepetition = newPasswordRepetition;
    }
}

export class UserPreferenceRequest extends GeneralRequest {
    userId:string = "";
    preferenceTypeId:number = -1;
    tableName:string = "";
    clearAll:boolean = false;
    preferenceInfos:Array<UserPreference> = [];

    constructor(id:string, typeId:number, tableName:string, clearAll:boolean, prefList:Array<UserPreference>) {
        super();
        this.userId = id;
        this.preferenceTypeId = typeId;
        this.tableName = tableName;
        this.clearAll = clearAll;
        this.preferenceInfos = prefList;
    }
}
